import PropTypes from 'prop-types';
import { Button, StatusMessage } from '@aimsos/ui';

import { TriangleAlert } from 'lucide-react';

/**
 * Error branch shared by every Data-step picker (CT-5191..5195).
 *
 * Split out of `PickerStates.jsx` (CT-5183 review) so the loading and error
 * branches each live in their own file, one component per file. The rule it
 * enforces: a failed load must render an error, never an empty list — an
 * empty list reads as "this source has nothing", a different and wrong
 * conclusion.
 */
export function PickerError({ title, subtitle, retryLabel, onRetry }) {
  return (
    <div className="flex flex-col items-center gap-3 py-4">
      <StatusMessage icon={TriangleAlert} title={title} subtitle={subtitle} />
      <Button variant="secondary" size="sm" onClick={onRetry}>
        {retryLabel}
      </Button>
    </div>
  );
}

PickerError.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  retryLabel: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default PickerError;
